import { render, staticRenderFns } from "./RedirectHandler.vue?vue&type=template&id=6f6d704b"
import script from "./RedirectHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./RedirectHandler.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f6d704b')) {
      api.createRecord('6f6d704b', component.options)
    } else {
      api.reload('6f6d704b', component.options)
    }
    module.hot.accept("./RedirectHandler.vue?vue&type=template&id=6f6d704b", function () {
      api.rerender('6f6d704b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/RedirectHandler.vue"
export default component.exports